// extracted by mini-css-extract-plugin
module.exports = {"title":"RadioButtonAnswers_title__3Ib7q","container":"RadioButtonAnswers_container__1Aegu","fadeImage":"RadioButtonAnswers_fadeImage__2raE8"};